import * as React from "react";
import { Box, Card, CardActionArea, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import {
  groupHash,
  groupImage,
  groupLabel,
  VinalfaGroup,
} from "../../../interfaces/Vinalfa";
import theme from "../../../theme";

type Props = {
  items: VinalfaGroup[];
  onSelect: (item: VinalfaGroup) => void;
};

const VinalfaGraphicCards = ({ items, onSelect }: Props) => {
  if (!items.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
        No diagrams in this group.
      </Typography>
    );
  }

  return (
    <Grid container spacing={2}>
      {items.map((item, index) => {
        const hash = groupHash(item);
        const label = groupLabel(item);
        const image = groupImage(item);
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} key={`${hash}-${index}`}>
            <Card
              elevation={1}
              sx={{
                borderRadius: 2,
                height: "100%",
                border: "1px solid #eee",
              }}
            >
              <CardActionArea
                onClick={() => onSelect(item)}
                sx={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "stretch" }}
              >
                <Box sx={{ position: "relative", bgcolor: "#fafafa", minHeight: 140 }}>
                  {image ? (
                    <CardMedia
                      component="img"
                      image={image}
                      alt={label}
                      sx={{
                        height: 160,
                        objectFit: "contain",
                        p: 1,
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        height: 160,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "text.secondary",
                        fontSize: 13,
                      }}
                    >
                      No preview
                    </Box>
                  )}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      bgcolor: "rgba(255,255,255,0.9)",
                      borderRadius: "50%",
                      width: 28,
                      height: 28,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ZoomInIcon sx={{ fontSize: 16, color: theme.palette.primary.main }} />
                  </Box>
                </Box>
                <CardContent
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    py: 1.5,
                    "&:last-child": { pb: 1.5 },
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: 13,
                      lineHeight: 1.3,
                    }}
                  >
                    {label}
                  </Typography>
                  <ArrowForwardIosIcon
                    sx={{ fontSize: 14, color: theme.palette.primary.main, flexShrink: 0 }}
                  />
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default VinalfaGraphicCards;
